// import httpApi from "@/apis/httpApi";
import CryptoJS from "crypto-js";
// 有协议就直接用，没有就补上（默认 https）
export function getNormalizedUrl(urlString) {
    const normalized =
        urlString && /^https?:\/\//i.test(urlString)
            ? urlString
            : urlString && urlString.startsWith("//")
            ? "https:" + urlString
            : "https://" + urlString;
    return new URL(normalized);
}

// 检测是否为文件上传请求
export function isFileUploadRequest(config) {
    if (!config.data) return false;
    // 检查是否为 FormData
    if (config.data instanceof FormData) return true;
    // 检查Content-Type
    const contentType =
        config.headers &&
        (config.headers["Content-Type"] || config.headers["content-type"]);
    if (contentType && contentType.includes("multipart/form-data")) return true;
    return false;
}

// 提取文件上传metaData
export function extractMetaData(data) {
    if (!data) return "";
    // 如果FormData，尝试获取meta 字段
    if (data instanceof FormData) {
        const meta = data.get("meta") || data.get("metaData");
        if (meta) {
            return typeof meta === "string" ? meta : JSON.stringify(meta);
        }
    }
    // 如果是普通对象，尝试获取 meta metaData 字段
    if (typeof data === "object" && data !== null) {
        const meta = data.meta || data.metaData;
        if (meta) {
            return typeof meta === "string" ? meta : JSON.stringify(meta);
        }
    }
    return "";
}

// 构造请求绝对地址（包含查询参数）
export function buildRequestPath(url, params, method) {
    let path = url.pathname;

    // GET请求需要将params编码后拼接到pathname
    if (method && method.toUpperCase() === "GET" && params) {
        const queryParams = new URLSearchParams();
        Object.keys(params).forEach((key) => {
            if (params[key] !== undefined && params[key] !== null) {
                queryParams.append(key, String(params[key]));
            }
        });
        const queryString = queryParams.toString();
        if (queryString) {
            path += "?" + queryString;
        }
    }
    return path;
}

// 处理请求体，返回字符串形式
export function getRequestBody(data, isFileUpload) {
    if (isFileUpload) {
        // 文件上传使用 metaData
        const metaData = extractMetaData(data);
        if (metaData) {
            // 限制长度300000字符以内
            return metaData.length > 300000
                ? metaData.substring(0, 300000)
                : metaData;
        }
        return "";
    }

    // POST请求转为JSON字符串
    if (data === null || data === undefined) {
        return "";
    }

    // 如果已经是字符串，检查是否是双重序列化的 JSON 字符串
    if (typeof data === "string") {
        // 如果字符串看起来是被 JSON.stringify 处理过的（包含转义引号），尝试解析一次
        if (data.startsWith('"') && data.includes('\\"')) {
            try {
                const parsed = JSON.parse(data);
                // 如果解析后还是字符串，说明确实是双重序列化，返回解析后的字符串
                if (typeof parsed === "string") {
                    return parsed.length > 300000
                        ? parsed.substring(0, 300000)
                        : parsed;
                }
                // 如果解析后是对象，重新序列化为字符串
                const jsonStr = JSON.stringify(parsed);
                return jsonStr.length > 300000
                    ? jsonStr.substring(0, 300000)
                    : jsonStr;
            } catch (e) {
                // 解析失败，说明不是有效的 JSON，直接返回原字符串
            }
        }

        return data.length > 300000 ? data.substring(0, 300000) : data;
    }

    // 转为JSON字符串
    const jsonStr = JSON.stringify(data);
    // const jsonStr = data;
    // 限制长度300000字符以内
    return jsonStr.length > 300000 ? jsonStr.substring(0, 300000) : jsonStr;
}

// hmacSha256 — 必须 toString()，避免 WordArray 参与字符串拼接出异常
function hmacSha256(message, secret) {
    return CryptoJS.HmacSHA256(message, secret).toString(CryptoJS.enc.Hex);
}

export function genNonce() {
    const chars = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
    ];
    let resNum = "";
    for (let i = 0; i < 32; i++) {
        const id = Math.ceil(Math.random() * 35);
        resNum += chars[id];
    }
    return resNum;
}

export function genSignMeta() {
    return {
        rqtime: Date.parse(String(new Date())),
        rqrandom: genNonce(),
    };
}

/** 从 URL query / form / JSON body 解析 V1 的 rqtime、rqrandom */
function extractV1SignMeta(source) {
    const meta = { rqtime: "", rqrandom: "" };
    if (source == null) return meta;

    if (typeof source === "object" && !Array.isArray(source)) {
        if (source.rqtime != null) meta.rqtime = String(source.rqtime);
        if (source.rqrandom != null) meta.rqrandom = String(source.rqrandom);
        return meta;
    }

    let text = String(source);
    try {
        text = decodeURIComponent(text);
    } catch (e) {
        // keep raw
    }

    // JSON body
    if (text.trim().startsWith("{")) {
        try {
            const obj = JSON.parse(text);
            if (obj && obj.rqtime != null) meta.rqtime = String(obj.rqtime);
            if (obj && obj.rqrandom != null) meta.rqrandom = String(obj.rqrandom);
            if (meta.rqtime || meta.rqrandom) return meta;
        } catch (e) {
            // fall through to query parse
        }
    }

    // query / form: a=1&rqtime=...&rqrandom=...
    const qIndex = text.indexOf("?");
    const query = qIndex >= 0 ? text.slice(qIndex + 1) : text;
    query.split("&").forEach((pair) => {
        const eq = pair.indexOf("=");
        if (eq < 0) return;
        const key = pair.slice(0, eq);
        const val = pair.slice(eq + 1);
        if (key === "rqtime") meta.rqtime = val;
        if (key === "rqrandom") meta.rqrandom = val;
    });
    return meta;
}

/** 强制让 V3 的 TIMESTAMP/NONCE 与请求里 V1 参数一致 */
function syncSignObjWithV1(signObj, requestBody) {
    if (!signObj) return signObj;
    const fromBody = extractV1SignMeta(requestBody);
    const fromUrl = extractV1SignMeta(signObj.url);
    const rqtime =
        (signObj.rqtime != null && signObj.rqtime !== ""
            ? String(signObj.rqtime)
            : "") ||
        fromBody.rqtime ||
        fromUrl.rqtime;
    const rqrandom =
        (signObj.rqrandom != null && signObj.rqrandom !== ""
            ? String(signObj.rqrandom)
            : "") ||
        fromBody.rqrandom ||
        fromUrl.rqrandom;
    if (rqtime) signObj.rqtime = rqtime;
    if (rqrandom) signObj.rqrandom = rqrandom;
    return signObj;
}

// E2SignCer
async function E2SignCer({ data, param, signObj }) {
    // 优先用同步后的 V1 参数；再从 url 兜底，禁止再 genNonce（否则 header 与明文不一致）
    const fromUrl = extractV1SignMeta(signObj && signObj.url);
    const resNum = String(
        (signObj && signObj.rqrandom) || fromUrl.rqrandom || "",
    );
    const rqtime = String(
        (signObj && signObj.rqtime) ||
            fromUrl.rqtime ||
            Date.parse(String(new Date())),
    );
    if (signObj) {
        let url = signObj.url;

        if (
            param &&
            typeof param === "object" &&
            !Array.isArray(param) &&
            Object.keys(param).length > 0
        ) {
            const paramstr = Object.entries(param)
                .map(([key, value]) => `${key}=${value}`)
                .join("&");
            if (paramstr !== "") {
                url = url.includes("?")
                    ? `${url}&${paramstr}`
                    : `${url}?${paramstr}`;
            }
        }
        let value = `${signObj.method}\n${url}\n${rqtime}\n${resNum}\n${
            signObj.deviceType
        }\n${signObj.deviceId ? signObj.deviceId : ""}\n${signObj.appv}\n${
            signObj.token ? signObj.token : ""
        }\n${navigator.userAgent}\n`;
        if (data) {
            if (Object.keys(data).length === 0) {
                //{}空对象
                value += `\n`;
            } else {
                value += `${data}\n`;
            }
        } else {
            //''空字符串
            value += `\n`;
        }
        // 以签名明文中的 time/nonce 为准拼 header，杜绝两套随机码
        const parts = value.split("\n");
        const signTime = parts[2] || rqtime;
        const signNonce = parts[3] || resNum;
        const signature = hmacSha256(value, process.env.VUE_APP_SIGN_KEY_501);
        return `BOXAPP-SHA256 NONCE=${signNonce};TIMESTAMP=${signTime};SIGNATURE=${signature}`;
    }
    const signature = hmacSha256("", process.env.VUE_APP_SIGN_KEY_501);
    return `BOXAPP-SHA256 NONCE=${resNum || genNonce()};TIMESTAMP=${rqtime};SIGNATURE=${signature}`;
}

export async function toSignV3(requestBody, signObj) {
    // 接口验签
    signObj.method = String(signObj.method || "").toUpperCase();
    // 这里保留对象处理逻辑仅作为兼容性保护
    let requestBodyStr = "";
    if (typeof requestBody === "string") {
        requestBodyStr = requestBody;
    } else if (requestBody !== undefined && requestBody !== null) {
        // 兼容性处理：如果直接传入对象，转为 JSON 字符串
        // 注意：正常情况下应该由 getRequestBody 处理，这里不应该执行
        try {
            requestBodyStr = JSON.stringify(requestBody);
        } catch (e) {
            requestBodyStr = "";
        }
    }
    const isGetMethod = signObj.method === "GET";
    // GET：从 url query 解析；POST：从 body 解析，强制 NONCE=rqrandom
    syncSignObjWithV1(
        signObj,
        isGetMethod ? signObj.url : requestBodyStr || requestBody,
    );
    const data = isGetMethod ? {} : requestBodyStr || {};
    const param = "";
    const sign = await E2SignCer({
        data,
        param,
        signObj,
    });
    return sign;
}
